import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cva, VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

export const Tabs = TabsPrimitive.Root

const tabListVariants = cva("inline-flex justify-start", {
  variants: {
    variant: {
      default: "bg-muted text-muted-foreground h-12 items-center rounded-md border",
      secondary: "h-10 items-end gap-4 text-sm font-medium",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

export interface TabsListProps
  extends React.ComponentPropsWithRef<typeof TabsPrimitive.List>, VariantProps<typeof tabListVariants> {}

export const TabsList = ({ className, variant, ...props }: TabsListProps) => (
  <TabsPrimitive.List className={cn(tabListVariants({ variant }), className)} {...props} />
)

export const tabButtonVariants = cva("tabs-trigger whitespace-nowrap", {
  variants: {
    variant: {
      default:
        "ring-offset-background data-[state=active]:border-on-primary-surface data-[state=active]:bg-primary-surface data-[state=active]:text-on-primary-surface hover:bg-surface-subdued-hovered data-[state=active]:hover:bg-primary-surface-hovered focus-visible:ring-ring inline-flex h-12 items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium transition-all focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border",
      secondary:
        "color text-on-surface-subdued data-[state=active]:text-on-surface hover:text-on-surface data-[state=active]:[&_.tabs-b-border]:bg-on-surface relative h-10 cursor-pointer py-2 [&_.tabs-b-border]:bg-transparent",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

export interface TabButtonProps
  extends React.ComponentPropsWithRef<typeof TabsPrimitive.Trigger>, VariantProps<typeof tabButtonVariants> {}

export const TabsTrigger = ({ className, children, variant, ...props }: TabButtonProps) => (
  <TabsPrimitive.Trigger className={cn(tabButtonVariants({ variant }), className)} {...props}>
    {variant === "secondary" ? (
      <div className="relative block">
        {children}
        <div className="tabs-b-border absolute bottom-0 h-0.5 w-full rounded-xs"></div>
      </div>
    ) : (
      children
    )}
  </TabsPrimitive.Trigger>
)

export const TabsContent = ({ className, ...props }: React.ComponentPropsWithRef<typeof TabsPrimitive.Content>) => (
  <TabsPrimitive.Content
    className={cn(
      "ring-offset-background focus-visible:ring-ring mt-2 px-3 py-3.5 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden",
      className,
    )}
    {...props}
  />
)
